import {
  Box,
  Grid,
  Skeleton,
  styled,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import HeaderGeneral from "../../components/Header/HeaderGeneral";
import { Profile } from "../../models/User";
import ProfileState from "../../recoil/ProfileState";
import ProfilePage from "./Components/ProfilePage";
import DataPribadiPage from "./DataPribadiPage/DataPribadiPage";
import QuestionnairePage from "./QuestionnairePage/QuestionnairePage";
import RiwayatPekerjaanPage from "./RiwayatPekerjaanPage/RiwayatPekerjaanPage";
import RiwayatPendidikanPage from "./RiwayatPendidikanPage/RiwayatPendidikanPage";
import SusunanKeluargaPage from "./SusunanKeluargaPage/SusunanKeluargaPage";
import KontakDaruratPage from "./KontakDaruratPage/KontakDaruratPage";
import KontakReferensiPage from "./KontakReferensiPage/KontakReferensiPage";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      sx={{ width: "100vw" }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `profile-tab-${index}`,
    "aria-controls": `profile-tabpanel-${index}`,
  };
}

const RootBox = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  display: "flex",
  minHeight: "90vh",
  height: "100%",
  width: "97vw",
  [theme.breakpoints.down("sm")]: {
    width: "90vw",
    display: "inline",
    bgcolor: "background.paper",
  },
}));

const BaseBox = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${process.env.PUBLIC_URL}/images/BackgroundJob.svg)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  [theme.breakpoints.down("sm")]: {
    backgroundSize: "cover",
  },
}));

export const GridSkeleton = styled(Grid)(({ theme }) => ({
  paddingLeft: "3vw",
  paddingTop: "1vh",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "5vw",
  },
}));

export const SkeletonText = styled(Skeleton)(({ theme }) => ({
  width: "40vw",
  height: "10vh",
  [theme.breakpoints.down("sm")]: {
    width: "60vw",
    height: "10vh",
  },
}));

export const SkeletonTable = styled(Skeleton)(({ theme }) => ({
  width: "75vw",
  height: "50vh",
  borderRadius: "20px",
  [theme.breakpoints.down("sm")]: {
    width: "90vw",
    height: "50vh",
  },
}));

type Props = {};

export default function ProfileTabPage({ }: Props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeTab = (newValue: number) => {
    setValue(newValue);
  };

  const theme = useTheme();

  const [condTabOrientation, setCondTabOrientation] = useState<
    "horizontal" | "vertical"
  >("horizontal");

  const isSmall = useMediaQuery(theme.breakpoints.up("sm"));

  useEffect(() => {
    if (isSmall) {
      setCondTabOrientation("vertical");
    } else {
      setCondTabOrientation("horizontal");
    }
  }, [isSmall]);

  const recoilValue = useRecoilValue(ProfileState);

  const [profileRecoil, setprofileRecoil] = useState<Profile>();

  useEffect(() => {
    if (recoilValue !== null) {
      setprofileRecoil(recoilValue);
    }
  }, [recoilValue]);

  return (
    <BaseBox>
      <HeaderGeneral />
      <RootBox>
        <Tabs
          value={value}
          onChange={handleChange}
          orientation={condTabOrientation}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="scrollable tabs"
          sx={{
            minWidth: "15vw",
            minHeight: "90vh",
            maxHeight: "100%",
            backgroundColor: "#FFF",
            boxShadow: " 1px 11px 10px 0px rgba(30, 30, 30, 0.1)",
            [theme.breakpoints.down("sm")]: {
              minWidth: "100%",
              minHeight: "6vh",
              height: "6vh",
            },
          }}
        >
          <Tab
            label={<Typography color="primary">Profile</Typography>}
            {...a11yProps(0)}
          />
          <Tab
            label={
              <Typography
                color={profileRecoil?.Data === false ? "error" : "primary"}
              >
                {profileRecoil?.Data === false ? "*" : ""}Data Pribadi
              </Typography>
            }
            {...a11yProps(1)}
          />
          <Tab
            label={
              <Typography
                color={
                  profileRecoil?.Pendidikan === false ? "error" : "primary"
                }
              >
                {profileRecoil?.Pendidikan === false ? "*" : ""}Riwayat Pendidikan
              </Typography>
            }
            {...a11yProps(2)}
          />
          <Tab
            label={
              <Typography
                color={profileRecoil?.Keluarga === false ? "error" : "primary"}
              >
                {profileRecoil?.Keluarga === false ? "*" : ""}Susunan Keluarga
              </Typography>
            }
            {...a11yProps(3)}
          />
          <Tab
            label={
              <Typography
                color={profileRecoil?.Pekerjaan === false ? "error" : "primary"}
              >
                {profileRecoil?.Pekerjaan === false ? "*" : ""}Riwayat Pekerjaan
              </Typography>
            }
            {...a11yProps(4)}
          />
          <Tab
            label={
              <Typography
                color={
                  profileRecoil?.Questionnaire === false ? "error" : "primary"
                }
              >
                {profileRecoil?.Questionnaire === false ? "*" : ""}Questionnaire
              </Typography>
            }
            {...a11yProps(5)}
          />
          <Tab
            label={
              <Typography
                color={
                  profileRecoil?.KontakDarurat === false ? "error" : "primary"
                }
              >
                {profileRecoil?.KontakDarurat === false ? "*" : ""}Kontak Darurat
              </Typography>
            }
            {...a11yProps(6)}
          />          <Tab
            label={
              <Typography
                color={
                  profileRecoil?.KontakReferensi === false ? "error" : "primary"
                }
              >
                {profileRecoil?.KontakReferensi === false ? "*" : ""}Kontak Referensi
              </Typography>
            }
            {...a11yProps(7)}
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          <ProfilePage handleTab={handleChangeTab} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DataPribadiPage />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <RiwayatPendidikanPage />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <SusunanKeluargaPage />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <RiwayatPekerjaanPage />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <QuestionnairePage />
        </TabPanel>
        <TabPanel value={value} index={6}>
          <KontakDaruratPage />
        </TabPanel>
        <TabPanel value={value} index={7}>
          <KontakReferensiPage />
        </TabPanel>
      </RootBox>
    </BaseBox>
  );
}
